import { appRoutes } from "lib/appRoutes";
import { SupplierMentionType } from "lib/types/graphQLEnums";

/**
 * The relationship page for a buyer and supplier, opened on all time: the page otherwise shows the
 * last three years, which would hide the award on an older notice.
 */
export function relationshipLink(buyerGuid: string, supplierGuid: string) {
  return {
    ...appRoutes.buyerSupplier({ buyerId: buyerGuid }, supplierGuid),
    search: { range: "all" },
  };
}

/**
 * Which awards count towards a notice's relationship: ones naming the supplier as well as direct
 * awards, matching the relationship page the notice links to.
 */
export const NOTICE_RELATIONSHIP_MENTION_TYPE = SupplierMentionType.MentionedOrDirectlyAwarded;
